import CareProviderInput from '../CareProviderInput';
import * as logger from '../../logger';

interface Props {
  id?: string;
  value: string;
  updateFieldValue: (value: string) => void;
  saveFieldValue: (value: string) => void;
}

export function CareProvider(props: Props) {
  const { id, value, updateFieldValue, saveFieldValue } = props;

  let careProviders = [];

  if (value) {
    try {
      const parsed = JSON.parse(value);
      careProviders = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      logger.error(e, `CareProvider: Failed parsing form field value ${value}`);
    }
  }

  return (
    <CareProviderInput
      id={id}
      saveFieldValue={saveFieldValue}
      updateFieldValue={updateFieldValue}
      initialCareProviders={careProviders}
    />
  );
}
